import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const AnalysisProgress = ({ progress }) => {
  const percentage = progress.total > 0 ? (progress.current / progress.total) * 100 : 0;

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="progress-card"
    >
      <div className="progress-header">
        <span className="progress-label">
          Analyzing websites...
        </span>
        <span className="progress-count">
          {progress.current} / {progress.total}
        </span>
      </div>

      <div className="progress-bar-container">
        <motion.div 
          className="progress-bar"
          initial={{ width: 0 }}
          animate={{ width: `${percentage}%` }}
          transition={{ duration: 0.3 }}
        />
      </div>

      <div className="progress-footer">
        <SafeIcon icon="FiClock" />
        <span>This may take a few minutes...</span>
      </div>
    </motion.div>
  );
};

export default AnalysisProgress;